import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const messages = {
  es: {
    opnq: '/about',
    quienes: 'Sobre Árbola',
    about: 'INFORMACIÓN ADICIONAL',
    cooperantes: 'INSTITUCIONES COOPERANTES',
    fundacionjocotoco: 'Fundación de Conservación Jocotoco',
    fundacionyakum: 'Fundación Yakum',
    reserves: 'ÁREAS DE REFORESTACIÓN',
    accede: 'Ingresa para apadrinar árboles y reforestar.',
    register: 'Ingresar',
    apadrinados: 'Árboles apadrinados:',
    por: 'Por',
    plantalo: '¡Apadrinar!',
    perfil: 'Mi perfil',
    cerrar: 'Cerrar sesión',
    editar: 'Editar perfil',
    misarboles: 'TUS ÁRBOLES EN',
    vermapa: 'VER EN MAPA',
    donar: '¡Obtén más semillas!',
    semillas: 'TUS SEMILLAS',
    comprarsemillas: 'Obtén semillas para',
    porcadasemilla: 'Por cada semilla que dones podrás apadrinar un árbol que tu elijas en la reserva seleccionada. Cada donación cubre la recolección de semillas, el cercado, la producción de plántulas, el establecimiento del vivero y la reforestación. Además tú árbol tiene garantizados 3 años de mantenimiento y cuidado. Contamos con la plataforma segura de pagos Paymentez. ¡Gracias por tu donación!',
    semillascant: 'Precio de cada semilla en',
    semillasmin: '¿Cuántos árboles quieres apadrinar?',
    donarsem: 'Donar Semillas',
    arbol: 'ÁRBOL',
    arboles: 'ÁRBOLES',
    cargando: 'Cargando...',
    plantadoel: 'APADRINADO EL',
    especie: 'INFORMACIÓN SOBRE EL ÁRBOL',
    verperfil: 'Ver perfil',
    nombreespecie: 'Nombre de la especie',
    nombrecientifico: 'Nombre científico',
    estado: 'Estado',
    elevacion: 'Elevación',
    region: 'Región',
    criterioseleccion: 'Criterios de selección',
    descripcion: 'Descripción',
    reserva: 'ÁREA DE REFORESTACIÓN',
    ecosistema: 'ECOSISTEMA DEL PROYECTO',
    volver: 'Volver',
    terminos: 'Términos y condiciones',
    politicas: 'Política de privacidad',
    plantar: 'Apadrinar árbol',
    registrarse: '¡Bienvenido! Inicia sesión o regístrate',
    conemail: 'Con tu correo electrónico',
    continuar: 'Continuar',
    redessociales: 'O con redes sociales',
    password: 'Contraseña',
    ingresapassword: '¡Estás a un paso de ingresar!',
    olvidadopassword: '¿Has olvidado tu contraseña?',
    ingresar: 'Continuar',
    informacion: 'Registrate ingresando la siguiente información',
    nombreusuario: 'Nombre del Perfil:',
    paisusuario: 'País de registro',
    empresausuario: '¿Eres una empresa o institución?',
    completoregistro: 'Continuar',
    registrousuario: 'Ingresa tu contraseña',
    errorcontrasena: 'Ha habido un error',
    contasenaincorrecta: 'La contraseña que ingresaste no es correcta. Por favor intenta de nuevo o recupera tu contraseña si la olvidaste.',
    cancelar: 'Cancelar',
    guardar: 'Guardar',
    cerrarsesion: 'Cerrar sesión',
    segurocerrar: '¿Seguro que quieres cerrar la sesión?',
    erroremailnovalido: 'Ha habido un error',
    emailnovalido: 'El correo electrónico ingresado no es válido. Porfavor, compruebalo nuevamente.',
    hemosenviadomail: 'Te hemos enviado un correo electrónico para que puedas recuperar tu contraseña.',
    usuarionocreado: 'Tu usuario no se ha podido crear.',
    rellenarcampos: 'Por favor, completa todos los campos antes de proceder.',
    usuarionoguardado: 'Tu perfil de usuario no se ha guardardado. Por favor, intentalo de nuevo.',
    apadrinarunarbol: '¡Apadrina este árbol!',
    tussemillas:'Tus Semillas',
    utilizarsemillas: 'Estás a punto de utilizar una de tus semillas para apadrinar este árbol:',
    necesitasunasemilla: 'Necesitas una semilla de',
    paraplantar: 'para apadrinar este árbol.',
    disponibleplantar: 'Disponible para ser apadrinado.',
    aceptolos: 'Acepto los',
    donacioncorrecta: 'Donación realizada correctamente. ¡Gracias por apoyar proyectos de reforestación y recuperación de ecosistemas! El equipo de la Fundación Red Forestal.',
    transaccionexito: 'La transacción se ha realizado con éxito. ¡Ahora puedes usar tus semillas para apadrinar árboles!',
    donacionnorealizada: 'Hay un problema con la donación. La donación no ha sido realizada, inténtalo de nuevo.',
    problematarjeta: 'Ha habido un problema con la transacción. Comprueba que la tarjeta introducida es válida e inténtalo de nuevo.',
    totaldonacion: 'Total: ',
    apadrinalo: '¡Apadrina árboles en esta reserva!',
    registrate: '¡Ingresa para apadrinar arboles!',
    dispongo:'O ingresa un código para recibir una semilla:',
    atencion: 'Atención!',
    crearcuenta: 'Registrate en Árbola',
    completar: '¡Comienza a apadrinar árboles!',
    informacionperfil: 'Ingresa la información de tu Perfil',
    plantarsemilla: '¡Plantar semilla!',
    semillasaleatoriasboton: 'Plantar todas aleatoriamente',
    semillasaleatoriastexto: 'Ninguna semilla se puede guardar por siempre. Recuerda que después de 15 días, tus semillas sin plantar, se asignarán a árboles automáticamente!',
    semillasaleatoriasmodaltitulo: '¿Estas seguro?',
    semillasaleatoriasmodalboton: 'Plantar semillas',
    semillasaleatoriasmodaltexto: 'Al dar click en Plantar semillas, tus semillas apadrinarán árboles aleatoriamente en la reserva seleccionada. Este proceso no puede ser revertido.',
    perfilcorreoelectronico: 'Correo electrónico:',
    perfilpaginaweb: 'Página web:',
    perfiltextocontrasena: 'Por favor, ingresa tu contraseña para confirmar el cambio de correo electrónico:',
    perfiltextoempresa: 'No estas registrado como empresa o institucion.',
    registropaisseleccion: 'Selecciona un país',
    passwordconfirmation: 'Por favor, repite tu contraseña:',
    verarboles: 'Visita los árboles',
    fundacionredforestal: 'Fundación Red Forestal',
    desarrolladopor: 'Desarollado por',
    imprimircertificado: 'Obten tu certificado de donación',
    perfilcertificadoheader: 'Confirma los datos de tu certificado',
    perfilcertificadotexto: 'Tu certificado de donación se enviará al correo electrónico registrado en tu perfil, una vez enviado, no se podrá cambiar el nombre.',
    perfilcertificadocorreo: 'Correo del certificado:',
    perfilcertificadonombre: 'Nombre del certificado:',
    perfilcertificadoenviar: 'Enviar certificado'
  },
  en: {
    opnq: '/about_us',
    quienes: 'About Árbola',
    about: 'ADDITIONAL INFORMATION',
    cooperantes: 'PARTNER ORGANIZATIONS',
    fundacionjocotoco: 'Jocotoco Conservation Foundation',
    fundacionyakum: 'Yakum Foundation',
    reserves: 'REFORESTATION AREAS',
    accede: 'Sign in to adopt trees and restore forests.',
    register: 'Enter',
    apadrinados: 'Adopted trees:',
    por: 'By',
    plantalo: 'Adopt tree!',
    perfil: 'My profile',
    cerrar: 'Sign out',
    editar: 'Edit your profile',
    misarboles: 'MY ADOPTED TREES IN',
    vermapa: 'SEE ON THE MAP',
    donar: 'Donate more seeds!',
    semillas: 'YOUR SEEDS',
    comprarsemillas: 'Donate seeds in',
    porcadasemilla: 'For every seed you donate you can sponsor a tree of your choice in the selected reserve. Each donation covers seed collection, fencing, seedling production, nursery establishment and reforestation. In addition, your tree is guaranteed 3 years of maintenance and care. We use the secure payments platform Paymentez. Thank you for your donation!',
    semillascant: 'Cost of each seed in',
    semillasmin: 'Seeds',
    donarsem: 'Donate seeds',
    arbol: 'TREE',
    arboles: 'TREES',
    cargando: 'Loading...',
    plantadoel: 'ADOPTED ON',
    especie: 'TREE INFORMATION',
    verperfil: 'View profile',
    nombreespecie: 'Species name',
    nombrecientifico: 'Scientific name',
    estado: 'Status',
    elevacion: 'Elevation',
    region: 'Region',
    criterioseleccion: 'Selection criteria',
    descripcion: 'Description',
    reserva: 'REFORESTATION ÁREA',
    ecosistema: 'ECOSYSTEM OF THE PROYECT',
    volver: 'Back',
    terminos: 'Terms and conditions',
    politicas: 'Privacy policy',
    plantar: 'Adopt this tree',
    registrarse: 'Hi there! Sign in or log in',
    conemail: 'With your email address',
    continuar: 'Continue',
    redessociales: 'Or with social networks',
    password: 'Password',
    ingresapassword: 'One more step to login!',
    olvidadopassword: 'Have you forgotten your password?',
    ingresar: 'Continue',
    informacion: 'Register completing the following information',
    nombreusuario: 'Profile name:',
    paisusuario: 'Profile registered in',
    empresausuario: 'Are you an enterprise or organisation?',
    completoregistro: 'Continue',
    registrousuario: 'Enter your password',
    errorcontrasena: 'There has been an error',
    contasenaincorrecta: 'The password you entered is incorrect. Please try again or reset your password if you forgot it.',
    cancelar: 'Cancel',
    guardar: 'Save',
    cerrarsesion: 'Sign out',
    segurocerrar: 'Are you sure you want to sign out?',
    erroremailnovalido: 'There has been an error',
    emailnovalido: 'The e-mail you entered is not valid. Please check it again.',
    hemosenviadomail: 'We have sent you an email so you can recover your password.',
    usuarionocreado: 'Your Profile could not be created.',
    rellenarcampos: 'Please complete all fields before proceeding.',
    usuarionoguardado: 'Your user profile has not been saved. Please try again.',
    apadrinarunarbol: 'Adopt this tree!',
    tussemillas:'Your Seeds',
    utilizarsemillas: 'You are about to use one of your seeds to adopt this tree:',
    necesitasunasemilla: 'You need a seed of ',
    paraplantar: 'to plant this tree.',
    disponibleplantar: 'Available for adoption.',
    aceptolos: 'I accept the',
    donacioncorrecta: 'Donation processed correctly. Thank you for supporting reforestation and ecosystem recovery projects! The Red Forestal Foundation team.',
    transaccionexito: 'The transaction was successful. Now you can use your seeds to adopt trees!',
    donacionnorealizada: 'There is a problem with your donation. The donation was not carried out, please try again',
    problematarjeta: 'There has been a problem with the transaction. Check that the card information is valid and try it again.',
    totaldonacion: 'Total: ',
    apadrinalo: 'Adopt trees in this reserve!',
    registrate: 'Sign in to adopt trees!',
    dispongo:'Enter a code to obtain a seed:',
    atencion: 'Atención!',
    crearcuenta: 'Create a Profile in Árbola',
    completar: 'Start adopting trees!',
    informacionperfil: 'Enter your Profile information',
    plantarsemilla: 'Plant a seed!',
    semillasaleatoriasboton: 'Plant your Seeds randomly',
    semillasaleatoriastexto: 'No seed can be stored forever. Remember, your unplanted seeds will automatically sponsor trees after 15 days!',
    semillasaleatoriasmodaltitulo: '¿Are you shure?',
    semillasaleatoriasmodalboton: 'Plant seeds',
    semillasaleatoriasmodaltexto: 'By clicking on Plant seeds, your seeds will randomly sponsor trees in the selected reserve. This process cannot be reversed.',
    perfilcorreoelectronico: 'Email:',
    perfilpaginaweb: 'Website:',
    perfiltextocontrasena: 'Please enter your password to confirm the email change:',
    perfiltextoempresa: 'Not registered as an enterprise or institution.',
    registropaisseleccion: 'Select a country',
    passwordconfirmation: 'Please repeat your password:',
    verarboles: 'Visit the trees',
    fundacionredforestal: 'Red Forestal Foundation',
    desarrolladopor: 'Developed by',
    imprimircertificado: 'Get your donation certificate',
    perfilcertificadoheader: 'Confirm your certificate data',
    perfilcertificadotexto: 'Your donation certificate will be sent to the email address registered in your profile, once sent, the name cannot be changed.',
    perfilcertificadocorreo: 'Registered email:',
    perfilcertificadonombre: 'Certificate name:',
    perfilcertificadoenviar: 'Send your certificate'
  },
  de:{
    opnq: '/about_de',
    quienes: 'Über Árbola',
    about: 'WEITERE INFORMATION',
    cooperantes: 'KOOPERATIONSPARTNER',
    fundacionjocotoco: 'Naturschutzstiftung Jocotoco',
    fundacionyakum: 'Stiftung Yakum',
    reserves: 'AUFFORSTUNGSGEBIETE',
    accede: 'Melde dich an, um Pate eines Baumes zu werden.',
    register: 'Anmelden',
    apadrinados: 'Gespendete Bäume:',
    por: 'Von',
    plantalo: 'Werde Pate!',
    perfil: 'Mein Profil',
    cerrar: 'Abmelden',
    editar: 'Profil bearbeiten',
    misarboles: 'MEINE BÄUME IN',
    vermapa: 'AUF DER KARTE SEHEN',
    donar: 'Erhalte weitere Samen!',
    semillas: 'MEINE SAMEN',
    comprarsemillas: 'Erhalte einen Samen für',
    porcadasemilla: 'Für jeden Samen, den du erhältst, kannst du die Patenschaft für einen Baum deiner Wahl in dem ausgewählten Aufforstunggebiet übernehmen. Jede Spende deckt das sammeln der Samen, den Zaun, die Setzlingsproduktion, die Einrichtung von Baumschulen und die Wiederaufforstung ab. Außerdem werden deinem Baum 3 Jahre Pflege und Wartung garantiert. Wir nutzen die sichere Zahlungsplattform Paymentez. Danke für deine Spende!',
    semillascant: 'Preis jedes Samen von',
    semillasmin: 'Samen',
    donarsem: 'Samen erhalten',
    arbol: 'BAUM',
    arboles: 'BÄUME',
    cargando: 'Laden...',
    plantadoel: 'PATE SEIT',
    especie: 'INFORMATION ÜBER DEN BAUM',
    verperfil: 'Zum Profil',
    nombreespecie: 'Name der Baumart',
    nombrecientifico: 'Wissenschaftlicher Name',
    estado: 'Status',
    elevacion: 'Höhenlage',
    region: 'Region',
    criterioseleccion: 'Auswahlskriterien',
    descripcion: 'Beschreibung',
    reserva: 'AUFFORSTUNGSGEBIET',
    ecosistema: 'ÖKOSYSTEM DES PROJEKTS',
    volver: 'Zurück',
    terminos: 'Allgemeine Geschäftsbedingungen',
    politicas: 'Datenschutzrichtlinien',
    plantar: 'Werde Pate',
    registrarse: 'Hallo! Melde dich an',
    conemail: 'Mit deiner Email Adresse',
    continuar: 'Weiter',
    redessociales: 'Oder mit sozialen Netzwerken',
    password: 'Passwort',
    ingresapassword: 'Letzter Schritt um dich anzumelden!',
    olvidadopassword: 'Hast du dein Passwort vergessen?',
    ingresar: 'Weiter',
    informacion: 'Melde dich nach der Angabde der folgenden Information an',
    nombreusuario: 'Profil Name:',
    paisusuario: 'Registriert in',
    empresausuario: 'Bist du ein Unternehmen oder eine Organisation?',
    completoregistro: 'Weiter',
    registrousuario: 'Gib dein Passwort an',
    errorcontrasena: 'Es gab einen Fehler',
    contasenaincorrecta: 'Das von dir eingegebene Passwort ist falsch. Bitte versuchen es erneut oder setz dein Passwort zurück, wenn du es vergessen hast.',
    cancelar: 'Abbrechen',
    guardar: 'Speichern',
    cerrarsesion: 'Abmelden',
    segurocerrar: 'Möchtest du dich abmelden?',
    erroremailnovalido: 'Ein Fehler isst aufgetreten',
    emailnovalido: 'Die eingegebene E-Mail Adresse ist ungültig. Bitte prüf deine E-Mail Adresse nochmals.',
    hemosenviadomail: 'Wir haben dir eine E-Mail gesendet, damit du dein Passwort wiederherstellen kannst.',
    usuarionocreado: 'Dein Profil konnte nicht erstellt werden.',
    rellenarcampos: 'Füllen Sie alle Felder aus, um fortfahren zu können.',
    usuarionoguardado: 'Das Profil konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    apadrinarunarbol: 'Werde Pate dieses Baumes!',
    tussemillas:'Deine Samen',
    utilizarsemillas: 'Du benutzt einen deiner Samen, um Pate dieses Baumes zu werden:',
    necesitasunasemilla: 'Du brauchst einen Samen von',
    paraplantar: 'um Pate dieses Baumes zu werden.',
    disponibleplantar: 'Man kann die Patenschaft für diesen Baum übernehmen.',
    aceptolos: 'Ich akzeptiere die',
    donacioncorrecta: 'Die Spende war erfolgreich. Danke für die Unterstützung von Wiederaufforstungs- und Ökosystemwiederherstellungsprojekten! Das Team der Stiftung Red Forestal.',
    transaccionexito: 'Die Transaktion war erfolgreich. Jetzt kannst du mit deinen Samen die Patenschaft für Bäume übernehmen!',
    donacionnorealizada: 'Es gab ein Problem mit der Spende. Die Spende wurde nicht getätigt, versuche es nochal.',
    problematarjeta: 'Es gab ein Problem mit der Transaktion. Bitte überprüf, ob die eingegebene Karte gültig ist und versuchen es noch einmal.',
    totaldonacion: 'Total: ',
    apadrinalo: 'Werde Pate eines Baumes!',
    registrate: 'Melde dich an um Pate zu werden!',
    dispongo:'Gib einen Kode an um Samen zu erhalten:',
    atencion: 'Atención!',
    crearcuenta: 'Registriere dich bei Árbola',
    completar: 'Werde Pate eines Baumes!',
    informacionperfil: 'Gib deine Profildaten an',
    plantarsemilla: 'Pflanze einen Samen!',
    semillasaleatoriasboton: 'Alle Samen zufällig pflanzen',
    semillasaleatoriastexto: 'Kein Samen kann für immer bewahrt werden. Denk daran, dass deine nicht gepflanzten Samen nach 15 Tagen automatisch Bäume sponsern!',
    semillasaleatoriasmodaltitulo: 'Bist du sicher?',
    semillasaleatoriasmodalboton: 'Pflanze deine Samen',
    semillasaleatoriasmodaltexto: 'Wenn du auf Pflanze deine Samen klicks, werden deine Samen, nach dem Zufallsprinzip, Bäume im ausgewählten Aufforstungsgebiet sponsern. Dieser Prozess kann nicht rückgängig gemacht werden.',
    perfilcorreoelectronico: 'Email Adresse:',
    perfilpaginaweb: 'Webseite:',
    perfiltextocontrasena: 'Bitte gib dein Passwort an, um die Email Änderung zu bestätigen:',
    perfiltextoempresa: 'Nicht als Unternehmen oder Institution registriert.',
    registropaisseleccion: 'Wähle ein Land aus',
    passwordconfirmation: 'Bitte gib dein Passwort erneuert an:',
    verarboles: 'Besuch die Bäume',
    fundacionredforestal: 'Stiftung Red Forestal',
    desarrolladopor: 'App Entwicklung',
    imprimircertificado: 'Erhalte deine Spendeurkunde',
    perfilcertificadoheader: 'Bestätige die Daten deiner Urkunde',
    perfilcertificadotexto: 'Ihre Spendeurkunde wird an die in Ihrem Profil registrierte E-Mail-Adresse gesendet, einmal versendet, kann der Name nicht mehr geändert werden.',
    perfilcertificadocorreo: 'E-Mail-Adresse:',
    perfilcertificadonombre: 'Name der Urkunde:',
    perfilcertificadoenviar: 'Urkunde senden'
  }
}

export const i18n = new VueI18n({
  locale: window.navigator.language.split('-')[0],
    fallbackLocale: 'en',
    messages
  })


// WEBPACK FOOTER //
// ./src/plugins/i18n.js